import SendIcon from '#/assets/svgs/SendIcon.svg';

function MessageInput({
  inputField,
  isSending,
  handleChange,
  handleEnterKeyPress,
  submitForm,
  placeholder = 'Write a message...',
}) {
  return (
    <div className="message-field">
      <input
        name="inputField"
        type="text"
        placeholder={placeholder}
        value={inputField}
        onChange={handleChange}
        onKeyDown={handleEnterKeyPress}
        disabled={isSending}
      />
      <button
        className={!!inputField.trim() && !isSending ? 'active' : ''}
        onClick={submitForm}
        disabled={!inputField.trim() || isSending}
      >
        <SendIcon />
      </button>
    </div>
  );
}

export default MessageInput;
